import React, { ReactNode, SetStateAction, useContext, useState } from "react";
import { Navtab } from "../../data/Navtab";
import "@fontsource-variable/montserrat";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Filters from "./Filters";
import { ArrowDown2, Logout } from "iconsax-react";
import Cookies from "js-cookie";
import { Popper } from "@mui/material";
import FilterCard from "../common/FilterCard";
import { ServiceContext } from "../../hooks/context/ServiceContext";

interface LayoutProps {
  children: ReactNode;
  pageName?: string;
  icon?: ReactNode;
  showFilter?: boolean;
  handleOpenCalendar?: () => void;
  activeTimeLine?: string;
  setActiveTimeLine?: SetStateAction<any>;
  handleTimeLine?: () => void;
  showTimeLine?: boolean;
  showMetrics?: boolean;
  showFilter2?: boolean;
  metricsTitle?: string;
  handleMetricsCheckboxChange?: (value: string, isChecked: boolean) => void;
  metricsSelectedValues?: string[];
  setMetricsSelectedValues?: SetStateAction<any>;
  metricsOptions?: { label: string; value: string }[];
  extraChildren?: ReactNode;
}

function Layout({
  children,
  pageName,
  icon,
  showFilter = true,
  handleOpenCalendar,
  activeTimeLine,
  setActiveTimeLine,
  handleTimeLine,
  showMetrics,
  showFilter2,
  showTimeLine,
  metricsTitle,
  handleMetricsCheckboxChange,
  metricsSelectedValues,
  setMetricsSelectedValues,
  metricsOptions,
  extraChildren,
}: LayoutProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { service, setService } = useContext(ServiceContext);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  // Maintain state for each dropdown separately
  const [openDropDowns, setOpenDropDowns] = useState<{
    [key: string]: boolean;
  }>({});

  const isLocation = (arg: string) => {
    return arg === location.pathname || location.pathname.includes(arg);
  };

  const toggleDropDown = (link: string) => {
    setOpenDropDowns((prevState) => ({
      ...prevState,
      [link]: !prevState[link],
    }));
  };

  return (
    <div className="flex flex-wrap justify-between relative pb-10">
      <div className="w-1/6">
        <div className="fixed sidebar bg-primary h-screen w-1/6 pt-4 overflow-scroll no-scrollbar">
          <div className="logo flex items-center justify-center mb-8">
            <img src="/logo/logo.svg" alt="" />
          </div>
          <div className="navtabs p-2">
            {Navtab.map((navItem) => (
              <>
                <div
                  className={`${isLocation(navItem.link) ? "bg-white" : "hover:bg-slate-700"} p-2 my-2 rounded cursor-pointer`}
                  onClick={() => {
                    if (!navItem.isDropdown) {
                      navigate(navItem.link);
                    } else {
                      toggleDropDown(navItem.link);
                    }
                  }}
                >
                  <li className={`flex gap-2 items-center capitalize text-xs list-none  ${isLocation(navItem.link) ? "text-primary font-bold" : "text-slate-300"}`}>
                    {isLocation(navItem.link) ? navItem.isActiveIcon : navItem.icon}
                    {navItem.name}
                    {navItem.isDropdown ? <ArrowDown2 /> : null}
                  </li>
                </div>
                <ul className="text-center text-xs font-bold capitalize cursor-pointer">
                  {openDropDowns[navItem.link]
                    ? navItem.fields.map((field) => (
                        <li className={`py-2 ${isLocation(field.link) ? "text-white underline" : "text-slate-300"}`} onClick={() => navigate(field.link)}>
                          {field.name}
                        </li>
                      ))
                    : null}
                </ul>
              </>
            ))}
            <div className={`hover:bg-slate-700 p-2 my-6 rounded cursor-pointer`}>
              <li
                className={` py-2 text-slate-300 flex list-none text-xs gap-2 items-center capitalize`}
                onClick={() => {
                  navigate("/");
                  Cookies.remove("access_token");
                }}
              >
                <Logout className="h-5 w-5" />
                Log out
              </li>
            </div>
          </div>
        </div>
      </div>
      <div className="w-5/6">
        <div className="topbar bg-white w-full h-20 flex justify-between items-center px-16">
          <div aria-describedby={id} onClick={handleClick}>
            <div className="font-semibold text-xl text-primary uppercase flex items-center gap-2 ">
              {service} <ArrowDown2 />{" "}
            </div>
          </div>
          <div className="relative w-24  h-12 bg-gray-200 rounded-full">
            <Link to="/profile">
              <img src="/logo/default_pic.jpeg" className="h-12 rounded-full absolute " alt="" />
            </Link>
            <ArrowDown2 className="h-12 rounded-full absolute right-2 text-2xl" />
          </div>
        </div>
        <div className="bg-gray-200 w-full min-h-screen px-10">
          <div className="pt-10">
            <div className="flex justify-between">
              <div className="flex items-center gap-2 text-4xl font-semibold text-primary">
                {icon}
                <h1 className="">{pageName}</h1>
              </div>
              {showFilter ? (
                <Filters
                  showFilter={showFilter2}
                  showMetrics={showMetrics}
                  showTimeLine={showTimeLine}
                  handleOpenCalendar={handleOpenCalendar}
                  handleTimeLine={handleTimeLine}
                  activeTimeLine={activeTimeLine ? activeTimeLine : ""}
                  setActiveTimeLine={setActiveTimeLine}
                  metricsTitle={metricsTitle}
                  handleMetricsCheckboxChange={handleMetricsCheckboxChange}
                  metricsSelectedValues={metricsSelectedValues}
                  setMetricsSelectedValues={setMetricsSelectedValues}
                  metricsOptions={metricsOptions}
                >
                  {extraChildren}
                </Filters>
              ) : null}
            </div>
            {children}
          </div>
        </div>
      </div>
      <Popper id={id} open={open} anchorEl={anchorEl}>
        <FilterCard>
          <ul className="mb-2">
            <li
              className={`py-4 px-3 text-primary font-medium  cursor-pointer hover:bg-slate-200 rounded-md ${service === "mtn" ? "bg-grey200" : ""} `}
              onClick={() => {
                setService("mtn");
              }}
            >
              MTN
            </li>
            <li
              className={`py-4 px-3 text-primary font-medium  cursor-pointer hover:bg-slate-200 rounded-md ${service === "glo" ? "bg-grey200" : ""} `}
              onClick={() => {
                setService("glo");
              }}
            >
              GLO
            </li>
          </ul>
        </FilterCard>
      </Popper>
    </div>
  );
}

export default Layout;
